
export function isEdge() {
	return /Edge/.test(navigator.userAgent);
}

export function isIphone() {
	return /iPhone/.test(navigator.userAgent);
}

export function isIpad() {
	return /iPad/.test(navigator.userAgent);
}

export function isIos() {
	if (isIphone() || isIpad()) {
		return true;
	} else {
		return false;
	}
}